export default "__VITE_ASSET__9367561a__"